/**
 * Portuguese strings for the player's own keys.
 *
 * Media Chrome ships this language for its controls; the keys the player adds,
 * casting, preview and its error messages, would otherwise fall back to English.
 */
import { Pt as MediaChromePt } from 'media-chrome/lang/pt.js';
import type { TranslateDictionary } from './en.js';

export const Pt: TranslateDictionary = {
  ...MediaChromePt,
  'Casting to {device}': 'Transmitindo para {device}',
  preview: 'Pré-visualização',
  "This video cannot be played on your device because it doesn't meet the content protection requirements.":
    'Este vídeo não pode ser reproduzido no seu dispositivo porque ele não atende aos requisitos de proteção de conteúdo.',
  'There was an error with the content protection system.':
    'Ocorreu um erro no sistema de proteção de conteúdo.',
  'This video requires a secure connection (HTTPS) to play DRM-protected content.':
    'Este vídeo requer uma conexão segura (HTTPS) para reproduzir conteúdo protegido por DRM.',
  'An error occurred during playback. The media could not be loaded.':
    'Ocorreu um erro durante a reprodução. Não foi possível carregar a mídia.',
  'This video uses a codec (HEVC) that is not supported by your browser. Please try a different browser such as Chrome or Safari.':
    'Este vídeo usa um codec (HEVC) que não é compatível com o seu navegador. Tente outro navegador, como Chrome ou Safari.',
  'There was an error during initialization of the DRM system.':
    'Ocorreu um erro ao inicializar o sistema DRM.',
  'The content license has expired.': 'A licença do conteúdo expirou.',
  'This video is not available.': 'Este vídeo não está disponível.',
  'This video could not be found.': 'Este vídeo não foi encontrado.',
};
